import { CloudWatchLogsClient, PutLogEventsCommand, } from "@aws-sdk/client-cloudwatch-logs";
const cloudwatchClient = new CloudWatchLogsClient({ region: "us-west-2" });
export function logError(message) {
    console.error(message);
    if (!process.env.CLOUDWATCH_LOG_GROUP_NAME) {
        return;
    }
    if (message.length > 262144) {
        message = message.substring(0, 262144);
    }
    return cloudwatchClient
        .send(new PutLogEventsCommand({
        logGroupName: process.env.CLOUDWATCH_LOG_GROUP_NAME,
        logStreamName: process.env.ENV,
        logEvents: [
            {
                timestamp: new Date().getTime(),
                message,
            },
        ],
    }))
        .catch((error) => {
        console.error(error.message);
    });
}
//# sourceMappingURL=log-error.js.map